import React from 'react';

export default props => {
  return (<div>
    {props.has_randomization_platform_step_3_surrogate ? <div dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_surrogate_content}} /> :
      <h4>Consent template not loaded</h4>
    }
  </div>);
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeTorontoUH/Texts/SurrogateElectronicText.js